<div id="section-toasters" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Toasters</p>

    <div class="m-t-20">
      <div class="toasters m-t--20">
        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-primary w-100" (click)="displayPrimary()">Primary</button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-success w-100" (click)="displaySuccess()">Success</button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-danger w-100" (click)="displayDanger()">Danger</button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-warning w-100" (click)="displayWarning()">Warning</button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-info w-100" (click)="displayInfo()">Info</button>
        </div>
      </div>
    </div>
  </div>
</div>
